import React from "react";
import { Target, Eye } from "lucide-react";
import {
 
  MapPin,
  FileCheck,
  BadgeCheck,
  Users
} from "lucide-react";
import Hero from "../assets/aboutBanner.png";
import farm from "../assets/about.png";

import {
  Leaf,
  ShieldCheck,
  Gem,
  Globe,
  CheckCircle
} from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../common/apiClient";
import SummaryApi from "../common/SummaryApi";
import { FaArrowRightLong } from "react-icons/fa6";
const AboutPage = () => {
  const [categories, setCategories] = useState([]);
const navigate = useNavigate();

useEffect(() => {
  const fetchCategories = async () => {
    try {
      const res = await api({
        url: SummaryApi.homeCategoryPreview.url,
        method: SummaryApi.homeCategoryPreview.method,
      });

      const data = res?.data?.data || [];

      setCategories(data.slice(0, 5)); // 🔥 only 5
    } catch (err) {
      console.log(err);
    }
  };

  fetchCategories();
}, []);
  return (
    <div className="bg-[#f4f5f2]">

      {/* HERO */}
      <div className="relative h-[70vh] md:h-[75vh] overflow-hidden">
        
        <img
          src={Hero}
          alt="banner"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/25 flex flex-col items-center justify-center text-white text-center px-4">
          <h1 className="text-5xl md:text-6xl font-times"> About KL Property</h1>
          <p className="mt-3 max-w-xl text-sm md:text-base">
            Honoring a 30-year family legacy in the heart of Idukki, Kerala. Where heritage meets the horizon.
          </p>
        </div>

      </div>

      {/* WHO WE ARE */}
      <section className="max-w-6xl mx-auto px-5 py-16 grid md:grid-cols-2 gap-12 items-center">

        {/* LEFT */}
        <div>
          <h2 className="text-3xl font-serif mb-6 text-gray-800">
            Who We Are
          </h2>

          <p className="text-gray-600 mb-4 leading-relaxed">
            KL Property is a trusted land and property service provider based
            in the beautiful hill regions of Thekkady, Kumily, and Idukki
            district of Kerala.
          </p>

          <p className="text-gray-600 mb-6 leading-relaxed">
            Our roots are deeply connected to agriculture and land
            development, with a legacy that dates from our grandfathers'
            time. For more than three decades, our family has been involved
            in cardamom plantations, pepper farming, and agricultural land
            development in this region.
          </p>

          <div className="flex gap-12 mt-6">
            <div>
              <p className="text-[#45A301] text-xl font-semibold">30+</p>
              <p className="text-sm text-gray-500">Years Experience</p>
            </div>

            <div>
              <p className="text-[#45A301] text-xl font-semibold">500+</p>
              <p className="text-sm text-gray-500">Happy Families</p>
            </div>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="relative">
          <img
            src={farm}
            alt="img"
            className="rounded-2xl shadow-lg object-cover h-[380px] w-full"
          />

          {/* FLOAT CARD */}
          <div className="absolute bottom-5 left-5 bg-white shadow-md rounded-lg px-4 py-3 text-xs text-gray-600 max-w-[220px]">
            “Agriculture is not just a profession, it's our legacy.”
          </div>
        </div>
      </section>

      {/* OUR APPROACH */}
      <section className="bg-[#e9ebe4] py-16 px-5">
        <div className="max-w-6xl mx-auto">

          <div className="text-center mb-12">
            <h2 className="text-3xl font-serif text-gray-800">
              Our Approach
            </h2>
            <p className="text-gray-500 mt-2">
              Integrity is the cornerstone of our family business.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">

            {/* LEFT CARD */}
            <div className="bg-white rounded-xl p-8 shadow-sm">
              <h3 className="text-lg font-medium mb-4">
                Not Typical Brokers
              </h3>

              <p className="text-gray-600 text-sm mb-5">
                At KL Property, we don't operate like typical brokers.
                We treat every customer like a friend and family member,
                providing:
              </p>

              <div className="space-y-3 text-sm text-gray-600">
                <div className="flex items-center gap-2">
                  <CheckCircle className="text-[#45A301]" size={16}/>
                  Honest advice
                </div>

                <div className="flex items-center gap-2">
                  <CheckCircle className="text-[#45A301]" size={16}/>
                  Genuine land options
                </div>

                <div className="flex items-center gap-2">
                  <CheckCircle className="text-[#45A301]" size={16}/>
                  Clear documentation support
                </div>

                <div className="flex items-center gap-2">
                  <CheckCircle className="text-[#45A301]" size={16}/>
                  Long-term trust and guidance
                </div>
              </div>
            </div>

            {/* RIGHT GRID */}
            <div className="grid grid-cols-2 gap-6">

              <div className="bg-[#dfe3d5] rounded-xl p-8 flex flex-col items-center justify-center text-center">
                <ShieldCheck className="text-[#45A301] mb-3" />
                <p className="text-sm font-medium">Legal Certainty</p>
              </div>

              <div className="bg-[#dfe3d5] rounded-xl p-8 flex flex-col items-center justify-center text-center">
                <Gem className="text-[#45A301] mb-3" />
                <p className="text-sm font-medium">Personal Trust</p>
              </div>

              <div className="bg-[#dfe3d5] rounded-xl p-8 flex flex-col items-center justify-center text-center">
                <Leaf className="text-[#45A301] mb-3" />
                <p className="text-sm font-medium">Eco Conscious</p>
              </div>

              <div className="bg-[#dfe3d5] rounded-xl p-8 flex flex-col items-center justify-center text-center">
                <Globe className="text-[#45A301] mb-3" />
                <p className="text-sm font-medium">Local Wisdom</p>
              </div>

            </div>

          </div>
        </div>
      </section>

      {/* WHAT WE OFFER */}
    <section className="bg-[#f4f5f2] py-16 px-5">
      <div className="max-w-6xl mx-auto">

        <h2 className="text-3xl font-serif text-center mb-12">
          What We Offer
        </h2>

        <div className="grid md:grid-cols-3 gap-8">

          {categories.map((item, index) => (
            <div
              key={index}
              onClick={() =>
                navigate(`/properties?category=${item.category.replace(/\s+/g, "-")}`)
              }
              className="bg-white rounded-xl shadow-sm overflow-hidden cursor-pointer hover:shadow-md transition"
            >
              <img
                src={item.heroImage?.url}
                alt={item.title}
                className="h-[280px] w-full object-cover"
              />

              <div className="p-5">
                <h3 className="font-medium mb-2 capitalize text-[#2F2F2F]">
                  {item.category}
                </h3>

                <p className="text-sm text-[#2F2F2FB2] mb-3 line-clamp-2">
                  {item.tagline}
                </p>

                <span className="flex items-center gap-2 text-[#45A301] text-sm font-semibold">
                  View Listings <FaArrowRightLong />
                </span>
              </div>
            </div>
          ))}

        </div>

      </div>
    </section>



    {/* OUR PROMISE */}
    <section className="bg-[#E2E8D7] py-16 px-5">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm p-10 text-center relative">

        {/* QUOTE ICON */}
        <div className="absolute right-8 top-6 text-6xl text-[#45A301] opacity-30">
          ”
        </div>

        <h2 className="text-3xl font-serif text-[#45A301] mb-4">
          Our Promise
        </h2>

        <p className="text-gray-600 mb-6">
          We are committed to helping you find the right property with confidence,
          safety, and peace of mind.
        </p>

        <p className="text-sm text-gray-500">
          — The Kurian Family, Founders
        </p>

      </div>
    </section>



    {/* MISSION VISION */}
    <section className=" py-16 px-5">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8">

        {/* MISSION */}
        <div className="bg-white rounded-xl shadow-sm p-8">
          
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#eef2e6] mb-4">
            <Target className="text-[#45A301]" size={20} />
          </div>

          <h3 className="text-xl font-serif mb-3">
            Our Mission
          </h3>

          <p className="text-gray-600 text-sm leading-relaxed">
            Our mission is to connect people with genuine land opportunities
            while maintaining transparency, trust, and long-term relationships
            with every client we serve.
          </p>

        </div>

        {/* VISION */}
        <div className="bg-white rounded-xl shadow-sm p-8">
          
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#eef2e6] mb-4">
            <Eye className="text-[#45A301]" size={20} />
          </div>

          <h3 className="text-xl font-serif mb-3">
            Our Vision
          </h3>

          <p className="text-gray-600 text-sm leading-relaxed">
            Our vision is to become the most trusted land advisory in the
            highlands of Kerala by preserving nature, supporting agriculture,
            and helping families invest in meaningful properties.
          </p>

        </div>

      </div>
    </section>




    {/* WHY CHOOSE US */}
    <section className=" py-8 px-5">
      <div className="max-w-6xl bg-white mx-auto py-8 px-8 rounded-xl shadow-sm">

        {/* Heading */}
        <h2 className="text-3xl font-serif text-center mb-12">
          Why Choose Us
        </h2>

        {/* Desktop */}
        <div className="hidden md:grid grid-cols-5 gap-8 text-center">

          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full shadow-lg bg-white mb-3">
              <Leaf className="text-[#45A301]" size={22} />
            </div>
            <p className="text-sm">
              30+ Years Agriculture Background
            </p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full shadow-lg bg-white mb-3">
              <MapPin className="text-[#45A301]" size={22} />
            </div>
            <p className="text-sm">
              Trusted Local Expertise
            </p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full shadow-lg bg-white mb-3">
              <FileCheck className="text-[#45A301]" size={22} />
            </div>
            <p className="text-sm">
              Clear Documentation Support
            </p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full shadow-lg bg-white mb-3">
              <BadgeCheck className="text-[#45A301]" size={22} />
            </div>
            <p className="text-sm">
              Transparent Property Deals
            </p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-12 h-12 flex items-center justify-center rounded-full shadow-lg bg-white mb-3">
              <Users className="text-[#45A301]" size={22} />
            </div>
            <p className="text-sm">
              Friendly Guidance
            </p>
          </div>

        </div>

        {/* Mobile Scroll */}
        <div className="md:hidden overflow-x-auto no-scrollbar">
          <div className="flex gap-8 px-2">

            <div className="min-w-[160px] flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full shadow-lg bg-white mb-3">
                <Leaf className="text-[#45A301]" size={22} />
              </div>
              <p className="text-sm">
                30+ Years Agriculture Background
              </p>
            </div>

            <div className="min-w-[160px] flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full shadow-lg bg-white mb-3">
                <MapPin className="text-[#45A301]" size={22} />
              </div>
              <p className="text-sm">
                Trusted Local Expertise
              </p>
            </div>

            <div className="min-w-[160px] flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full shadow-lg bg-white mb-3">
                <FileCheck className="text-[#45A301]" size={22} />
              </div>
              <p className="text-sm">
                Clear Documentation Support
              </p>
            </div>

            <div className="min-w-[160px] flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full shadow-lg bg-white mb-3">
                <BadgeCheck className="text-[#45A301]" size={22} />
              </div>
              <p className="text-sm">
                Transparent Property Deals
              </p>
            </div>

            <div className="min-w-[160px] flex flex-col items-center text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full shadow-lg bg-white mb-3">
                <Users className="text-[#45A301]" size={22} />
              </div>
              <p className="text-sm">
                Friendly Guidance
              </p>
            </div>

          </div>
        </div>

      </div>
    </section>

    </div>
  );
};

export default AboutPage;